import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const ExecutiveTaskGroup = () => {
  const [teamData, setTeamData] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch('/content/team.json')
      .then(res => res.json())
      .then(data => {
        setTeamData(data);
        setLoading(false);
      })
      .catch(error => {
        console.error('Error loading team data:', error);
        setLoading(false);
      });
  }, []);

  // Filter executive members from board members
  const getExecutiveMembers = () => {
    if (!teamData.boardMembers) return [];

    return teamData.boardMembers.filter(member =>
      member.role === 'President' ||
      member.role === 'Vice-President' ||
      member.role === 'Treasurer' ||
      member.role === 'Secretary'
    );
  };
  const memberCardStyle = {
    backgroundColor: '#ffffff',
    padding: '1.5rem',
    borderRadius: '12px',
    border: '1px solid #e5e7eb',
    boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
    textAlign: 'center',
    transition: 'all 0.3s ease'
  };

  const sectionStyle = {
    marginBottom: '3rem',
    padding: '2rem',
    backgroundColor: '#f8fafc',
    borderRadius: '16px',
    border: '1px solid #e2e8f0'
  };

  return (
    <div className="container" style={{maxWidth: '1200px', margin: '0 auto', padding: '2rem'}}>
      {/* Header */}
      <div style={{textAlign: 'center', marginBottom: '3rem'}}>
        <Link 
          to="/task-groups" 
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            color: '#2563eb',
            textDecoration: 'none',
            marginBottom: '1rem',
            fontSize: '1rem'
          }}
        >
          ← Back to Task Groups
        </Link>
        <h1 className="page-title" style={{fontSize: '2.5rem', fontWeight: 'bold', color: '#1e293b', marginBottom: '1rem'}}>
          👥 Executive Task Group
        </h1>
        <p className="page-subtitle" style={{fontSize: '1.2rem', color: '#64748b', maxWidth: '800px', margin: '0 auto'}}>
          Representing EBTA in general matters and responsible for administration and governance
        </p>
      </div>

      {/* Description */}
      <div style={sectionStyle}>
        <div style={{display: 'flex', alignItems: 'center', marginBottom: '1.5rem'}}>
          <div style={{fontSize: '2rem', marginRight: '1rem'}}>📋</div>
          <h2 style={{fontSize: '1.8rem', fontWeight: 'bold', color: '#1e293b', margin: 0}}>About the Executive Task Group</h2>
        </div>
        <p style={{color: '#64748b', fontSize: '1.1rem', lineHeight: '1.6', marginBottom: '1.5rem'}}>
          The executive task-group represents EBTA in general matters and is responsible for the administration and book keeping of the association. 
          The executive task-group is formed annually as part of the EBTA Board election. It consists of the president, vice-president, secretary and treasurer. 
          The maximum time of duty for each position is three years, with the possibility of being re-elected at the Members Annual Meeting (MAM).
        </p>
        <p style={{color: '#64748b', fontSize: '1.1rem', lineHeight: '1.6'}}>
          The president represents EBTA, chairs the Board meetings and the Members Assembly and follows-up on the boards' decisions. 
          The vice president represents EBTA and chairs the Board meetings in the absence of the president. 
          The secretary keeps and circulates the notes of Board meetings and of the Members Assembly, sends out and receives communications with EBTA members. 
          The treasurer administrates the budget of EBTA and presents an annual balance to the Members Assembly.
        </p>
      </div>

      {/* Members */}
      <div style={sectionStyle}>
        <div style={{display: 'flex', alignItems: 'center', marginBottom: '2rem'}}>
          <div style={{fontSize: '2rem', marginRight: '1rem'}}>👥</div>
          <h2 style={{fontSize: '1.8rem', fontWeight: 'bold', color: '#1e293b', margin: 0}}>Current Members</h2>
        </div>
        
        {loading ? (
          <div style={{textAlign: 'center', padding: '2rem'}}>
            <p style={{color: '#6b7280', fontSize: '1.1rem'}}>Loading team members...</p>
          </div>
        ) : (
          <div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '1.5rem'}}>
            {getExecutiveMembers().map((member, index) => {
              // Define role colors
              const getRoleColor = (role) => {
                switch(role) {
                  case 'President':
                    return { bg: '#dbeafe', color: '#1e40af' };
                  case 'Vice-President':
                    return { bg: '#dcfce7', color: '#166534' };
                  case 'Treasurer':
                    return { bg: '#fef3c7', color: '#a16207' };
                  case 'Secretary/PR':
                    return { bg: '#fdf4ff', color: '#7c2d12' };
                  default:
                    return { bg: '#f3f4f6', color: '#6b7280' };
                }
              };

              const roleColors = getRoleColor(member.role);

              // Define role descriptions
              const getRoleDescription = (role) => {
                switch(role) {
                  case 'President':
                    return 'Represents EBTA, chairs Board meetings and Members Assembly, follows up on board decisions.';
                  case 'Vice-President':
                    return 'Represents EBTA and chairs Board meetings in the absence of the president.';
                  case 'Treasurer':
                    return 'Administrates the budget of EBTA and presents annual balance to the Members Assembly.';
                  case 'Secretary':
                    return 'Administers Board meetings, Members Annual Meeting and takes care of communication with members.';
                  default:
                    return 'Executive task group member.';
                }
              };

              return (
                <div key={index} style={memberCardStyle}>
                  <div style={{
                    width: '120px',
                    height: '120px',
                    borderRadius: '50%',
                    backgroundColor: '#f3f4f6',
                    margin: '0 auto 1rem',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '3rem',
                    color: '#6b7280',
                    backgroundImage: member.image ? `url(${member.image})` : 'none',
                    backgroundSize: 'cover',
                    backgroundPosition: 'center'
                  }}>
                    {!member.image && '👤'}
                  </div>
                  <h3 style={{color: '#1e293b', fontSize: '1.3rem', fontWeight: '600', marginBottom: '0.5rem'}}>
                    {member.name}
                  </h3>
                  <div style={{
                    backgroundColor: roleColors.bg,
                    color: roleColors.color,
                    padding: '0.5rem 1rem',
                    borderRadius: '20px',
                    fontSize: '0.9rem',
                    fontWeight: '600',
                    display: 'inline-block',
                    marginBottom: '1rem'
                  }}>
                    {member.role}
                  </div>
                  <p style={{color: '#6b7280', fontSize: '0.9rem', lineHeight: '1.5', marginBottom: '1rem'}}>
                    {getRoleDescription(member.role)}
                  </p>
                  
                  {/* Contact links */}
                  <div style={{display: 'flex', gap: '0.5rem', justifyContent: 'center', flexWrap: 'wrap'}}>
                    {member.email && (
                      <a 
                        href={`mailto:${member.email}`}
                        style={{
                          padding: '0.25rem 0.5rem',
                          backgroundColor: '#f3f4f6',
                          borderRadius: '4px',
                          textDecoration: 'none',
                          fontSize: '0.8rem',
                          color: '#6b7280'
                        }}
                      >
                        📧
                      </a>
                    )}
                    {member.website && (
                      <a 
                        href={member.website}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{
                          padding: '0.25rem 0.5rem',
                          backgroundColor: '#f3f4f6',
                          borderRadius: '4px',
                          textDecoration: 'none',
                          fontSize: '0.8rem',
                          color: '#6b7280'
                        }}
                      >
                        🌐
                      </a>
                    )}
                    {member.linkedin && (
                      <a 
                        href={member.linkedin}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{
                          padding: '0.25rem 0.5rem',
                          backgroundColor: '#f3f4f6',
                          borderRadius: '4px',
                          textDecoration: 'none',
                          fontSize: '0.8rem',
                          color: '#6b7280'
                        }}
                      >
                        💼
                      </a>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>

      {/* Contact */}
      <div style={{...sectionStyle, backgroundColor: '#f1f5f9', textAlign: 'center'}}>
        <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '1.5rem'}}>
          <div style={{fontSize: '2rem', marginRight: '1rem'}}>📧</div>
          <h2 style={{fontSize: '1.8rem', fontWeight: 'bold', color: '#1e293b', margin: 0}}>Get in Touch</h2>
        </div>
        <p style={{fontSize: '1.1rem', color: '#64748b', marginBottom: '2rem', maxWidth: '600px', margin: '0 auto 2rem'}}>
          Have questions about EBTA governance or administration? Contact our Executive Task Group.
        </p>
        <Link 
          to="/contact"
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            backgroundColor: '#2563eb',
            color: 'white',
            padding: '1rem 2rem',
            borderRadius: '10px',
            textDecoration: 'none',
            fontWeight: '600',
            fontSize: '1rem',
            boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
            transition: 'all 0.3s ease'
          }}
          onMouseEnter={(e) => {
            e.target.style.backgroundColor = '#1d4ed8';
            e.target.style.transform = 'translateY(-2px)';
            e.target.style.boxShadow = '0 10px 15px -3px rgba(0, 0, 0, 0.1)';
          }}
          onMouseLeave={(e) => {
            e.target.style.backgroundColor = '#2563eb';
            e.target.style.transform = 'translateY(0)';
            e.target.style.boxShadow = '0 4px 6px -1px rgba(0, 0, 0, 0.1)';
          }}
        >
          <span style={{marginRight: '0.5rem'}}>📧</span>
          Contact Us
        </Link>
      </div>
    </div>
  );
};

export default ExecutiveTaskGroup;
